import { useState, useEffect } from "react";
import { Navigation } from '../components/navigation';
import { Header } from "../components/header";
import { Features } from "../components/features";
import { Contact } from "../components/contact";
import JsonData from "./data/data.json";
import "./LandingPage.css";

const LandingPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default LandingPage;
